import LayoutByAuth from './LayoutByAuth';

export default LayoutByAuth;
